import { ReactElement } from 'react'

import getMFEConfig from 'helpers/getMFEConfig'
import SyfDisputesCenter, { DisputeFeature } from 'digital-disputes'
import useHandleNavigate from 'hooks/useHandleNavigate'
import useNavigateOnRedirect from 'hooks/useNavigateOnRedirect'
import { useAtomValue } from 'jotai'
import { selectedAccountAtom } from 'store/atoms'
import { DisputesTableWrapper } from './subcomponents'

const DisputesCenter = (): ReactElement => {
  const { handleNavigate } = useHandleNavigate()

  const selectedAccount = useAtomValue(selectedAccountAtom)

  useNavigateOnRedirect()

  const disputesConfig = getMFEConfig('disputes')

  return (
    <DisputesTableWrapper>
      <SyfDisputesCenter
        disputesMFEConfig={disputesConfig}
        accountId={selectedAccount}
        feature={DisputeFeature.DisputeCenter}
        navigationHandler={handleNavigate}
        returnToParent={() => null}
      />
    </DisputesTableWrapper>
  )
}

export default DisputesCenter
